import { useNumberSerialiser } from "hooks/serialisers/numbers";

export const useInventoryNumberSerialiser = () => {
  return useNumberSerialiser<number | null | undefined>({
    decimalPlaces: 2,
    default: { value: null, text: "" },
  });
};
